import styled from 'styled-components'
import React from 'react'

const StyledSeriesSwitcher = styled.nav`
  background: #f9fafa;
  border: 1px solid #eef0f1;
  border-radius: 5px;
  margin-bottom: var(--spacing-8);

  .series-switcher__header {
    color: inherit;
  }
  .series-switcher__header-title {
    margin: var(--spacing-3);
    font-size: var(--fontSize-2);
  }
  .series-switcher__link {
    display: flex;
    align-items: center;
    border-top: 1px solid #eef0f1;
    padding: var(--spacing-3);
    color: var(--link-color);
    text-decoration: none;
  }
  .series-switcher__link:hover .series-switcher__title {
    color: var(--link-color-hover);
  }
  .series-switcher__num {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    margin-right: var(--spacing-2);
    color: inherit;
    background: #eef0f1;
    border-radius: 2rem;
  }
  .series-switcher__link.isActive .series-switcher__num {
    color: white;
    background: var(--color-primary);
  }
  .series-switcher__title {
    max-width: 100%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .series-switcher__link.isActive .series-switcher__title {
    font-weight: 700;
  }
`

export const SeriesSwitcher = ({ title, series, currentSlug }) => {
  return (
    <StyledSeriesSwitcher>
      <header className="series-switcher__header">
        <h3 className="series-switcher__header-title">
          {title} ({series.length} Part Series)
        </h3>
      </header>
      <div className="series-switcher__list">
        {series.map((post, index) => {
          const isActive = post.fields.slug === currentSlug ? 'isActive' : ''
          return (
            <a
              className={`series-switcher__link ${isActive}`}
              href={post.fields.slug}
              key={index}
            >
              <span className="series-switcher__num">{index + 1}</span>
              <span className="series-switcher__title">
                {post.frontmatter.title}
              </span>
            </a>
          )
        })}
      </div>
    </StyledSeriesSwitcher>
  )
}
